import back from "@assets/web-v3-images/btn-Back.png";

const BackIcon = ({ width = 96, height = 96, className }) => (
  <img src={back} alt="" width={width} height={height} className={className} />
);

export default BackIcon;
